import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "vaulted" },
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const mediaSrc = (url) => (url ? (url.startsWith("http") ? url : `${BACKEND}${url}`) : null);

export const money = (cents) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format((cents || 0) / 100);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_2d5166dc-72e1-4bef-974c-914b178fb948/artifacts/31c272f5f1c5b27c_Logo.png";

export const DELIVERY_LABEL = { licence_key: "Instant Delivery", manual: "Manual Delivery", download: "Instant Download", discord_ticket: "Discord Ticket" };
export const PLATFORMS = ["PC", "PlayStation", "Xbox", "Switch", "Mobile"];
export const num = (n) => new Intl.NumberFormat("en-AU").format(n || 0);

export const hasRole = (user, ...roles) => !!user && roles.some((r) => user.roles?.includes(r));

export const can = (user, perm) => !!user?.permissions?.includes(perm);
